import { Navigate } from "react-router-dom";
const PrivateRoute = ({ element }) => {
  const token = localStorage.getItem('jwt');
  return token ? element : <Navigate to="/login" />;
};

export default PrivateRoute;
